import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ICheckoutSession, ILineItem, IProduct, IProfile, IResponse } from '@interfaces/index';
import { AuthorizationService } from '@ui-components/services';
import { AppService } from '@ui-components/services';
import { PaymentService } from '../../services/payment.service';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  loading = false;
  products: IProduct[] = [];
  line_items: ILineItem[] = [];
  billing_type: number | undefined;
  profile: IProfile | null = null;

  get isSuperSuperAdmin(): boolean {
    return this._authorization_service.isSuperSuperAdmin(this.profile);
  }

  constructor(
    protected _app_service: AppService,
    protected _product_service: ProductService,
    protected _payment_service: PaymentService,
    protected _authorization_service: AuthorizationService,
    public dialog_ref: MatDialogRef<ProductsComponent>
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this._app_service.getProfile().subscribe({
      next: (response: IResponse<IProfile>) => {
        this.billing_type = response.data.billingtype_id;
        this.profile = response.data;
        this.loadProducts();
      },
      error: (error: HttpErrorResponse) => {
        this._app_service.notify('Failed to fetch profile. Please try again later.', 'error');
        console.error('Error fetching profile:', error);
        this.loading = false;
      }
    });
  }

  loadProducts() {
    this._product_service.standardProducts().subscribe(
      (response: IResponse<IProduct[]>) => {
        this.products = response.data;
        this.loading = false;
      },
      (response: HttpErrorResponse) => {
        this._app_service.notify(response.message, 'error')
        this.loading = false;
      }
    );
  }

  checkout() {
    this.line_items = this.products.filter(
      (item: IProduct) => {
        return item.qty && item.qty > 0;
      }
    ).map(
      (item: IProduct) => {
        return {
          id: item.id,
          quantity: item.qty ?? 0,
          price: item.default_price
        };
      }
    )

    if (this.billing_type === 2 || this.isSuperSuperAdmin) {
      this.checkoutWithoutPayment();
    } else {
      this.checkoutWithPayment(this.line_items);
    }
  }

  checkoutWithPayment(products: ILineItem[]) {
    this._payment_service.checkout(products).subscribe(
      (response: IResponse<ICheckoutSession>) => {
        window.location.href = response.data.url
      }
    )
  }

  checkoutWithoutPayment(): void {
    this._payment_service.billMeLater(this.line_items, this.profile?.org_id).subscribe({
      next: () => {
        const option = this.isSuperSuperAdmin ? 'Defer' : 'Bill Me Later';
        this._app_service.notify(`Order placed successfully with '${option}' option.`, 'success');
        this.dialog_ref.close(true);
      },
      error: (error: HttpErrorResponse) => {
        this._app_service.notify(error.message, 'error');
      }
    });
  }

  updateQuantity(qty: number, product: IProduct) {
    product.qty = qty;
  }
}
